export function useAutoFocus<T extends HTMLElement>(el: T) {
  useEffect(() => {
    el?.focus();
  }, [el]);
}
